<textarea
  pTextarea
  [formErrorDirective]="formName"
  tabindex="{{ tabIndex }}"
  [formControl]="control"
  [placeholder]="placeholder ? placeholder : name"
  [rows]="numRows"
  class="form-control"
></textarea>
